module.exports = __webpack_public_path__ + "static/media/ehome_c.ed364f14.png";